import { render, staticRenderFns } from "./PostFight.vue?vue&type=template&id=6db4d17c&"
import script from "./PostFight.vue?vue&type=script&lang=js&"
export * from "./PostFight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports